import { colorsPalettes } from "@similarweb/styles";
import type { FC } from "react";
import { SWReactIcons } from "@similarweb/icons";
import {
    BackButtonStyled,
    BackButtonText,
    BlueTag,
    Container,
    FirstColumnText,
    HeaderText,
    ItemData,
    ItemText,
    PackageTag,
    PackageTagText,
    StyledCell,
    StyledHeaderCell,
    StyledRow,
    StyledTable,
    Title,
} from "app/components/React/AfterTrialHook/ComparePackages/stylesComponents";
import { translate } from "app/filters/i18nFilter";
import { TableData } from "app/components/React/AfterTrialHook/ComparePackages/tableData";
import { PlainTooltip } from "@similarweb/ui-components";

interface IPurchaseList {
    onClickBack: (isOpen: boolean) => void;
    isSkippedCCUser: boolean;
}

export const ComparePackagesTable: FC<IPurchaseList> = ({ onClickBack, isSkippedCCUser }) => {
    const onCloseClick = () => {
        onClickBack(false);
    };
    return (
        <Container>
            <BackButtonStyled
                iconName="arrow-left"
                type="flat"
                onClick={onCloseClick}
            >
                <BackButtonText>{translate("pro.after.trial.hook.popup.left.back.button")}</BackButtonText>
            </BackButtonStyled>
            <Title>{translate("pro.after.trial.hook.popup.table.title")}</Title>
            <PackageTag>
                <PackageTagText>
                    {translate(
                        !isSkippedCCUser
                            ? "pro.purchase.plan.data.table.tag.trial"
                            : "pro.purchase.plan.data.table.tag.after.trial",
                    )}
                </PackageTagText>
            </PackageTag>
            <BlueTag />
            <StyledTable>
                <thead>
                    <tr>
                        <StyledHeaderCell
                            width="40%"
                            withBorder={false}
                        />
                        <StyledHeaderCell
                            width="30%"
                            withBorder={true}
                            background={colorsPalettes.carbon[25]}
                        >
                            <HeaderText>{translate("pro.purchase.plan.data.table.basic.cell")}</HeaderText>
                        </StyledHeaderCell>
                        <StyledHeaderCell
                            width="30%"
                            withBorder={true}
                            background={colorsPalettes.carbon[0]}
                        >
                            <HeaderText>{translate("pro.purchase.plan.data.table.starter.cell")}</HeaderText>
                        </StyledHeaderCell>
                    </tr>
                </thead>
                <tbody>
                    {TableData.map((item, index) => (
                        <StyledRow key={item.id}>
                            <StyledCell width="40%">
                                <FirstColumnText>
                                    <ItemText>{translate(item.text)}</ItemText>
                                    <PlainTooltip tooltipContent={translate(item.tooltip)}>
                                        <span>
                                            <SWReactIcons
                                                iconName="info"
                                                size="xs"
                                            />
                                        </span>
                                    </PlainTooltip>
                                </FirstColumnText>
                            </StyledCell>
                            <StyledCell
                                width="30%"
                                background={colorsPalettes.carbon[25]}
                            >
                                {item.basic ? <ItemData>{translate(item.basic)}</ItemData> : null}
                                {item.basicIcon ? (
                                    <ItemData>
                                        <SWReactIcons
                                            iconName={item.basicIcon}
                                            size={"xs"}
                                            iconColor={colorsPalettes.carbon[200]}
                                        />
                                    </ItemData>
                                ) : null}
                            </StyledCell>
                            <StyledCell width="30%">
                                {item.starter ? <ItemData>{translate(item.starter)}</ItemData> : null}
                                {item.starterIcon ? (
                                    <ItemData>
                                        <SWReactIcons
                                            iconName={item.starterIcon}
                                            size="xs"
                                            iconColor={colorsPalettes.blue[350]}
                                        />
                                    </ItemData>
                                ) : null}
                            </StyledCell>
                        </StyledRow>
                    ))}
                </tbody>
            </StyledTable>
        </Container>
    );
};
